import { render, staticRenderFns } from "./TenderStatusList.vue?vue&type=template&id=dedd27e8&"
import script from "./TenderStatusList.vue?vue&type=script&lang=js&"
export * from "./TenderStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports